import FileUploader from 'components_newui/new_ui_file_uploader/View'
import React, { useEffect, useState } from 'react'


export const FileUploaderFn = (props)=>{
    
    const {
      onDocumentUpload,
      documentIdeaKey=undefined,
      match,isDocumentLoading,
      documents,csrf,isAdmin,
      isInnovator,isOwner,
      localAdmin,localInnovator,isEvaluator,isOwnerInnovate,
      isInnovateDocuement,IdeaIDKey, onDocumentDelete} = props
    
    
    
    const handleDocumentUpload = (file) => {
        if (isInnovateDocuement) {
          onDocumentUpload(IdeaIDKey, file, documentIdeaKey);
        } else {
          onDocumentUpload(documentIdeaKey, file);
        }
    };
      
    
    const handleDeleteDocument = (documentId) =>{
        // const { onDocumentDelete } = props
        const id = match && match.params && match.params.id ? match.params.id : undefined
        if (isInnovateDocuement) {
          onDocumentDelete(IdeaIDKey, documentId)
        }else{
          onDocumentDelete(id, documentId)
        }
    }

        return(
            <FileUploader
              dropText="Browse file"
              isDocumentLoading={isDocumentLoading}
              onFileSelect={handleDocumentUpload}
              documentfiles={documents}
              handleDeleteDocument={handleDeleteDocument}
              csrfToken={csrf}
              canDelete={isAdmin || isInnovator || isEvaluator || isOwner || localAdmin || localInnovator || isOwnerInnovate}
          />
        )
    }
  
  